<template>
  <div class="pdf-preview" v-show="visible">
    <div class="pdf-wrapper">
      <Draggable :controlEl="el" :fill="true">
        <div class="head">
          <Icon :src="require('@/assets/images/hl.png')" size="16" style="margin-right: 0.5rem" />
          <span>PDF预览</span>
          <div class="close-btn" @click="handleClose">
            <div class="area-popup_close">
              <Icon :src="require('@/assets/images/close.png')" size="24" />
            </div>
          </div>
        </div>
      </Draggable>
      <div class="pdf-container" v-if="visible">
        <div class="pdf-sidebar" v-if="pageCount > 1">
          <div class="thumbnail-list" v-loading="loadingThumbnails" element-loading-text="拼命加载中" element-loading-background="rgba(0, 0, 0, 0.8)">
            <div 
              v-for="page in pageCount" 
              :key="page"
              class="thumbnail-item"
              :class="{ active: currentPage === page }"
              @click="handlePageChange(page)"
            >
              <pdf
                :src="pdfUrl"
                :page="page"
                :resize="true"
                :scale="0.3"
                @loaded="() => handleThumbnailLoaded(page)"
              ></pdf>
              <div class="page-number">第 {{ page }} 页</div>
            </div>
          </div>
        </div>
        <div class="pdf-content">
          <div class="pdf-loading" v-if="loading" v-loading="loading">
          </div>
          <pdf
            v-if="pdfUrl"
            :src="pdfUrl"
            :page="currentPage"
            :scale="0.5"
            :resize="true"
            @num-pages="handleNumPages"
            @page-loaded="pageLoaded"
            @loaded="loading=false"
            @error="pdfError"
          ></pdf>
        </div>
      </div>
      <div class="download-btn" v-if="canDownload">
        <el-button type="primary" @click="downloadPdf">下载</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import Icon from "@/components/UI/Icon";
import Draggable from "@/components/Popup/Draggable.vue";
export default {
  name: 'PdfPreview',
  components: {
    pdf,
    Icon,
    Draggable
  },
  data() {
    return {
      el: null,
      visible: false,
      pdfUrl: '',
      currentPage: 1,
      pageCount: 0,
      loading: true,
      loadedThumbnails: new Set(),
      loadingThumbnails: true
    }
  },
  computed: {
    canDownload() {
      return this.$store.state.userRights.get('download_fish_info')
    }
  },
  methods: {
    handleClose() {
      this.visible = false
      this.currentPage = 1
      this.pageCount = 0
      this.loadedThumbnails.clear()
      this.loading = true
      this.loadingThumbnails = true
    },
    handlePageChange(val) {
      this.currentPage = val
    },
    pageLoaded() {
      // 页面加载完成的回调
    },
    pdfError(error) {
      this.$message.error('PDF加载失败')
      this.handleClose()
    },
    handleThumbnailLoaded(page) {
      this.loadedThumbnails.add(page)
      console.log(this.loadedThumbnails.size, this.pageCount)
      if (this.loadedThumbnails.size === this.pageCount) {
        this.loadingThumbnails = false
      }
    },
    handleNumPages(num) {
      this.pageCount = num
    },
    async downloadPdf() {
      const response = await fetch(this.pdfUrl);
      const blob = await response.blob();
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.setAttribute('download', `${this.pdfUrl.split('/').pop()}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  mounted() {
    this.el = this.$el
  }
}
</script>

<style lang="scss" scoped>
.pdf-preview {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  height: 90%;
  z-index: 2000;
}

.pdf-wrapper {
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);

  .head {
    padding: 12px 16px;
    color: white;
    background-color: rgba(68, 138, 202, 1);
    position: relative;
    text-align: left;
    box-sizing: border-box;
    flex-shrink: 0;

    .area-popup_close {
      position: absolute;
      top: 50%;
      right: 16px;
      transform: translateY(-50%);
      cursor: pointer;
      transition: all ease-out 0.25s;
      display: flex;
      justify-content: center;
      align-items: center;

      &:hover {
        transform: translateY(-50%) rotate(180deg);
      }
    }
  }

  .pdf-container {
    flex: 1;
    display: flex;
    background: #525659;
    height: max-content;
    overflow: auto;
    .pdf-sidebar {
      width: 200px;
      background: #383838;
      border-right: 1px solid #666;
      overflow-y: auto;
      padding: 10px;
      position: relative;

      .thumbnail-list {
        .thumbnail-item {
          margin-bottom: 10px;
          cursor: pointer;
          border: 2px solid transparent;
          border-radius: 4px;
          transition: all 0.3s;
          position: relative;
          min-height: 100px;

          .thumbnail-placeholder {
            width: 100%;
            height: 100px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #f5f5f5;
            border-radius: 2px;
          }

          &.active {
            border-color: #409EFF;
          }

          &:hover {
            border-color: #66b1ff;
          }

          .page-number {
            text-align: center;
            color: #fff;
            font-size: 12px;
            margin-top: 5px;
          }

          ::v-deep pdf {
            background: white;
            border-radius: 2px;
          }
        }
      }
    }

    .pdf-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      position: relative;
      padding: 20px;
      height: calc(100% - 40px);
      overflow: auto;

      .pdf-loading {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 1;
      }

      ::v-deep pdf {
        flex: 1;
        display: flex;
        justify-content: center;
        overflow: auto;
        background: #525659;

        .vuepdfiframe {
          background: white;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
          margin: 0 auto;
          pointer-events: none;
          transform: scale(0.8);
          transform-origin: top center;
        }
      }
    }
  }
  .download-btn {
    text-align: center;
    padding: 10px;
  }
}

</style> 


// WEBPACK FOOTER //
// src/components/PdfPreview/PdfPreview.vue